import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";

const cn = (...inputs) => twMerge(clsx(inputs));

/**
 * Low-emphasis inline action (link style). Stops propagation so it can sit inside
 * clickable rows/cards without triggering them.
 */
const TextButton = ({ children, onClick, tooltip, disabled = false, isLoading = false, loadingText, className }) => {
  const button = (
    <button
      type="button"
      disabled={disabled || isLoading}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.(event);
      }}
      className={cn(
        "shrink-0 rounded-md px-1.5 py-0.5 text-xs font-medium text-secondary transition-colors hover:bg-secondary/10 disabled:cursor-not-allowed disabled:opacity-60",
        isLoading && "cursor-wait",
        className,
      )}
    >
      {isLoading && loadingText ? loadingText : children}
    </button>
  );
  return tooltip ? <CustomCommonTooltip content={tooltip}>{button}</CustomCommonTooltip> : button;
};

export default TextButton;
